import Dialog from "@mui/material/Dialog";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { Icon } from "@iconify/react";

export default function ComponentPopup({
  openPopup,
  componentToPassDown,
  setOpenPopup,
  title,
  paperClass,
  onClose,
}) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClose = () => {
    setOpenPopup(false);
    onClose?.();
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      open={openPopup}
      onClose={handleClose}
      aria-labelledby="responsive-dialog-title"
      className="mui-component-popup"
      PaperProps={{ className: `theme-card ${paperClass || ""}` }}
    >
      <div className="d-flex justify-content-between mb-2">
        <h3 className="text-primary">{title}</h3>
        <button className="popup-cross-icon" onClick={handleClose}>
          <Icon icon={"maki:cross"} />
        </button>
      </div>
      <div className="show-component-center">{componentToPassDown}</div>
    </Dialog>
  );
}
